<template>
  <div class="bind-main">
    <div class="bind-main-head">
      <img @click="clickHandler('/h5/login')" data-track-text="返回登录" aria-label="返回登录" style="margin-left: 28px" src="../assets/H5/go-back.png" alt=""/>
      <div>协议</div>
    </div>
    <div class="bind-main-content">
      <div class="bind-main-content-title">
        尊敬的用户，您好！ <br/>
        请在使用微思翻译系列产品之前，仔细阅读《用户服务协议》，<br/>
        并确保充分理解本协
      </div>
      <div class="bind-main-lanmu" style="margin-top: 40px;">
        一、简介
      </div>
      <div class="bind-main-text">
        本协议为用户与微思翻译平台之间的服务协议，微思翻译本着精细化和个性化服务的原则，竭诚为用户提供机器翻译及相关服务。用户应当在仔细阅读、充分理解本协议中所有内容，确认同意之后，合理使用微思翻译所提供的服务。如本协议中的相关条款无法获得用户认同，我们不建议用户使用本产品。
      </div>
      <div class="bind-main-text">
        微思翻译平台上出现的相关引导、操作提示、使用帮助，向用户展示使用方法、规则、流程等等，此类内容是构成微思翻译服务平台相关规则的一部分，与本协议具有同等效力。
        用户接受本协议之后，本协议可能会因国家政策、产品与/或服务以及履行本协议的环境发生改变而进行修改，修改后的协议将在本平台的适当位置进行展示，请用户及时查阅。如用户在本协议更新后继续使用本服务，即表示用户已仔细阅读、充分理解并接受更新后的协议。
      </div>
      <div class="bind-main-text">
        如在阅读本协议过程中有任何疑惑或问题，欢迎与我们（北京容智科技发展有限公司）取得联系，我尽快为您解答。
      </div>
      <div class="bind-main-lanmu" style="margin-top: 40px;">
        二、服务内容
      </div>
      <div class="bind-main-text-other">
        微思翻译服务将以有偿或无偿服务的形式进行提供。
      </div>
      <div class="bind-main-text-other">
        1、服务平台网址：包括但不限定于w esitrans.com、wesitrans.cn。
      </div>
      <div class="bind-main-text-other">
        2、用户服务终端：包括但不限定于PC、平板、手机。
      </div>
      <div class="bind-main-text-other">
        3、用户服务等级：存在机构用户、个人用户的区别，服务方式或者内容略有不同。
      </div>
      <div class="bind-main-lanmu">
        三、用户使用规则
      </div>
      <div class="bind-main-text-other2">
        1、允许用户合理合法使用本服务平台，禁止任何以恶意破解为目的等非法手段，干扰或破坏本服务平台的行为，如有发现，我司将立即通知相关执法机关，保留依法追其法律责任的权利，由此引发的一切法律后果将由该行为人负责。
      </div>
      <div class="bind-main-text-other2">
        2、用户应通过合法手段获取本平台的使用资格，不得以未经授权的途径获取服务资格，否则将认定为非法获取，一经查获，本平台概不承认其使用资格，并有权立即删除、封号等，收回其使用权利，由此产生的一切后果与本平台无关，均由用户自行承担。微思翻译将保留依法追究其法律责任的权利。
      </div>
      <div class="bind-main-text-other2">
        3、禁止用户在本平台上，制作、上传、复制、传送、传播包含任何反对宪法所确定的基本原则、危害国家安全、泄露国家秘密、颠覆国家政权、破坏国家统一、破坏民族团结、损害国家荣誉和利益、煽动民族仇恨、民族歧视、破坏民族团结、破坏国家宗教政策、宣扬邪教和封建迷信、淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪、侮辱或者诽谤他人，侵害他人合法权益的等法律、行政法规禁止的内容或其它令人反感的包括但不限于资讯、资料、文字、照片、图形、信息或其他资料，或者利用账号进行违法、欺骗等违法活动，一经发现，平台有权不经通知进行封号、注销等，本平台保留依法报案或者协助公检机关的权利。
      </div>
      <div class="bind-main-text-other2">
        4、用户不得故意冒用他人身份，使用他人手机号等信息注册使用账号，如手机号或者邮箱所有人提供确实证据，我方将对冒用账号进行注销，并保留追究其责任的权利。
      </div>
      <div class="bind-main-text-other2">
        5、用户不得恶意使用本平台，不得将账号转让、出借、出租、售卖或分享予他人使用。如发现，平台将立即进行封号处理。
      </div>
      <div class="bind-main-text-other2">
        6、用户知悉并同意，由于宽带及网络因素，提供服务的过程中可能会需要较长等待时间，此类情况，请用户予以理解。
      </div>
      <div class="bind-main-lanmu">
        四、用户数据保密
      </div>
      <div class="bind-main-text-other2">
        1、本平台提供服务时，基于服务的便利性，需要收集用户的手机号等信息，微思翻译承诺将对该类信息进行完全保密，绝不会泄露给平台以外的第三方机构。
      </div>
      <div class="bind-main-text-other2">
        2、用户同意接收微思翻译向用户在平台注册的手机号码、邮箱地址发送服务和商业信息，用以通知服务或者更改密码等。若用户不再需要这些信息，可通知我司取消发送。
      </div>
      <div class="bind-main-text-other2">
        3、本平台将对用户上传文档及翻译后的文档进行保密，绝不会将用户的上述数据对外公开或提供给任何第三方，且只允许本用户在一定时间范围内进行查阅，超出时间，将自动消除，不予保留备份。
      </div>
      <div class="bind-main-text-other2">
        4、如用户使用本平台从事违反国家法律法规的文档进行翻译，我方将根据相关法律法规的规定，或行政机关的要求，向行政机关、司法机关或其他执法机关进行披露。
      </div>
      <div class="bind-main-text-other2">
        5、用户在使用的过程中，应遵守以下法律法规：《中华人民共和国保守国家秘密法》、《中华人民共和国著作权法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《互联网电子公告服务管理规定》、《信息网络传播权保护条例》、《中华人民共和国网络安全法》等相关计算机及互联网的其他法律、法规、规定。
      </div>
      <div class="bind-main-text-other2">
        6、未经微思翻译事先明确书面许可，禁止以任何方式（包括但不限于机器人软件、蜘蛛软件、爬虫软件等任何自动程序、脚本、软件）和任何理由自行或委托他人、协助他人获取平台的服务、内容、数据。如发现，将保留追究其刑事责任的权利。
      </div>
      <div class="bind-main-lanmu">
        五、知识产权
      </div>
      <div class="bind-main-text">
        受国际版权公约、中华人民共和国著作权法、专利法、及其他知识产权方面的法律法规的保护，微思翻译的服务，所使用的软件、界面、交互等元素、LOGO、商标、标识、技术等的所有知识产权归北京容智科技发展有限公司所有和享有，不允许第三方侵犯行为。
      </div>
      <div class="bind-main-text">
        用户不得修改、改编微思翻译所使用的软件、技术等，或者创作与之相关的派生作品，不得通过反向工程、反编译或其他类似行为获得其源代码，否则由此引起的一切法律后果由用户负责，将依法追究法律责任。
      </div>
      <div class="bind-main-lanmu" style="margin-top: 40px">
        六、用户须知
      </div>
      <div class="bind-main-text-other2">
        1、用户理解并同意，微思翻译提供的机器翻译服务品质是由现有技术和条件所决定的，微思翻译不对提供服务品质作出任何明示或暗示的承诺或保证。
      </div>
      <div class="bind-main-text-other2">
        2、用户理解并同意，如出现由于服务器或网络发生故障导致影响平台的正常运行的情况，平台将尽快进行修复，对于出现不可抗力，导致确实无法在短时间内恢复正常运行的，平台将无法承担由此造成的损失。
      </div>
      <div class="bind-main-text-other2">
        3、用户理解并同意，如为了改善用户体验、提高服务品质，微思翻译将不定时进行更新及维护，由此产生的短时间内的服务异常，敬请谅解。
      </div>
      <div class="bind-main-text-other2">
        4、用户理解并同意，如因不可抗力、黑客攻击、网络中断等因素造成使用服务中断，平台将尽快排除故障，提供正常服务，敬请谅解。
      </div>
      <div class="bind-main-text-other2">
        5、用户理解并同意，平台提供的翻译内容将由网络途径进行上传及下载服务，由于非本平台提供的下载途径获取的文档出现木马等，本平台将不承担任何责任。
      </div>
      <div class="bind-main-lanmu" style="margin-top: 40px">
        七、服务的变更、中断及终止
      </div>
      <div class="bind-main-text-other2">
        1、购买服务期满，或者充值型服务用尽之时，本平台将自动停止本用户的服务。
      </div>
      <div class="bind-main-text-other2">
        2、用户主动提出要求终止服务的，将以双方沟通结果为准，进行相关处理。
      </div>
      <div class="bind-main-text-other2">
        3、本平台有权根据其业务情况及用户情况，暂时或永久得中断或者终止服务，对于有偿服务用户将进行通知，并对费用进行核算清算，对于无偿服务用户无通知义务。
      </div>
      <div class="bind-main-lanmu" style="margin-top: 40px">
        八、联系方式
      </div>
      <div class="bind-main-text-other2">
        1、用户可通过平台内的反馈功能，进行意见的在线提交，我方将尽快给予答复。
      </div>
      <div class="bind-main-text-other2">
        2、用户还可以通过业务负责人进行信息反馈。
      </div>
      <div class="bind-main-text-other2">
        本协议内容均应适用于中华人民共和国大陆地区法律，与本协议相关的任何纠纷，双方应协商友好解决
      </div>
      <div class="bind-main-text-other2" style="text-align: right;margin-top: 30px;margin-bottom: 150px">
        北京容智科技发展有限公司<br/>
        2020年9月1日
      </div>
    </div>
    <div class="main-foot" style="flex-flow: column">
      <div>
        © 2020 北京容智科技发展有限公司 京ICP备19036872号-3 All
        rights reserved. 京公网安备 11011402010815号
      </div>
      <div style="margin-top: 10px">
        <a href="mailto:info@wiseivy.com.cn?subject=微思翻译咨询">联系邮箱：info@wiseivy.com.cn</a>
        <span style="margin-left: 15px">联系电话：010-80755328</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewAgreement",
  methods: {
    clickHandler(url) {
      this.$router.push(url)
    }
  }
}
</script>

<style lang="less" scoped>
.bind-main {
  min-width: 768px;
  width: 100%;
  background: #ffffff;
  display: flex;
  flex-flow: column;
  align-items: center;

  .bind-main-head {
    width: 100%;
    height: 88px;
    background: #E6E6E6;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    display: flex;
    align-items: center;

    div {
      flex: 1;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      text-align: center;
      margin-right: 60px;
    }
  }

  .bind-main-content {
    margin-top: 35px;
    width: 768px;
    background: #FFFFFF;
    display: flex;
    align-items: center;
    flex-flow: column;

    .bind-main-content-title {
      width: 672px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      line-height: 36px;
    }

    .bind-main-text-other {
      width: 683px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      line-height: 36px;
      margin-bottom: 40px;
    }

    .bind-main-text-other2 {
      width: 683px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      line-height: 36px;
      margin-bottom: 40px;
      text-align: justify;
    }

    .bind-main-text {
      width: 683px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      line-height: 36px;
      text-indent: 50px;
      text-align: justify;
    }

    .bind-main-lanmu {
      margin-bottom: 20px;
      width: 672px;
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
    }
  }

  .main-foot {
    height: 149px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #F5F5F5;
    width: 100%;

    div {
      width: 667px;
      height: 64px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #00233E;
      line-height: 36px;
    }
  }
}

@media (max-width: 768px) {
  .bind-main {
    width: 100%;
    min-width: 0;
    overflow-x: hidden;
  }

  .bind-main-head {
    height: 56px !important;
    font-size: 17px !important;
  }

  .bind-main-head > img {
    width: 28px;
    height: 28px;
    margin-left: 12px !important;
    object-fit: contain;
  }

  .bind-main-head > div {
    margin-right: 40px !important;
    font-size: 17px !important;
  }

  .bind-main-content {
    width: 100% !important;
    margin-top: 0 !important;
    padding: 20px 16px calc(84px + env(safe-area-inset-bottom));
    box-sizing: border-box;
  }

  .bind-main-content-title,
  .bind-main-text-other,
  .bind-main-text-other2,
  .bind-main-text,
  .bind-main-lanmu {
    width: 100% !important;
    box-sizing: border-box;
  }

  .bind-main-content-title,
  .bind-main-text-other,
  .bind-main-text-other2,
  .bind-main-text {
    margin-bottom: 20px !important;
    font-size: 14px !important;
    line-height: 24px !important;
    text-indent: 2em !important;
  }

  .bind-main-lanmu {
    margin-top: 12px !important;
    margin-bottom: 10px !important;
    font-size: 18px !important;
  }

  .main-foot {
    display: none !important;
  }
}
</style>
